import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  BusinessTypeLookup,
  LeadAssigneeLookup,
  LeadStageLookup,
} from '../../../services/lookup-api.service';
import { businessTypeLabel } from './business-types';

@Component({
  selector: 'app-lead-profile-fields',
  templateUrl: './lead-profile-fields.component.html',
  styleUrls: ['./lead-profile-fields.component.css'],
})
export class LeadProfileFieldsComponent {
  @Input({ required: true }) form!: FormGroup;
  @Input() loading = false;
  @Input() stagesLoading = false;
  @Input() repsLoading = false;
  @Input() stages: LeadStageLookup[] = [];
  @Input() reps: LeadAssigneeLookup[] = [];
  @Input() businessTypesLoading = false;
  @Input() businessTypes: BusinessTypeLookup[] = [];

  repName(rep: LeadAssigneeLookup): string {
    return rep.displayName?.trim() || rep.userName?.trim() || `User ${rep.id}`;
  }

  typeLabel(name: string): string { return businessTypeLabel(name); }

  /**
   * The categories chosen, as rows rather than ids.
   *
   * A picker over ninety options is a dropdown that ADDS and a chip that
   * removes, not a ctrl-click multi-select: the chips say what the lead is
   * without anybody scrolling a list to find out which lines are highlighted.
   */
  get chosenBusinessTypes(): BusinessTypeLookup[] {
    const chosen = this.chosenIds;
    return this.businessTypes.filter(type => chosen.includes(type.id));
  }

  /** What is left to choose. A category cannot be added to a lead twice. */
  get addableBusinessTypes(): BusinessTypeLookup[] {
    const chosen = this.chosenIds;
    return this.businessTypes.filter(type => !chosen.includes(type.id));
  }

  addBusinessType(event: Event): void {
    const select = event.target as HTMLSelectElement;
    const id = Number(select.value);
    // Back to the prompt, so the control reads "Add a business type" again
    // rather than naming the one just added as though it were the whole answer.
    select.value = '';
    if (!Number.isInteger(id) || id <= 0) return;
    if (this.chosenIds.includes(id)) return;
    this.setChosen([...this.chosenIds, id]);
  }

  removeBusinessType(id: number): void {
    this.setChosen(this.chosenIds.filter(chosen => chosen !== id));
  }

  private get chosenIds(): number[] {
    return (this.form.get('businessTypeIds')?.value as number[] | null) ?? [];
  }

  private setChosen(ids: number[]): void {
    const control = this.form.get('businessTypeIds');
    control?.setValue(ids);
    // Touched as well as dirty: this control is written by buttons, and an
    // untouched control would keep its validation quiet until something else
    // on the form was typed into.
    control?.markAsDirty();
    control?.markAsTouched();
  }
}
